import { Link } from "react-router-dom";
import { ArrowRight, Facebook, Instagram, Phone } from "lucide-react";
import { nav, logoLockupGold, footerVandaImg } from "@/data";
import { useBooking } from "@/context/BookingContext";

export default function Footer() {
  const { openBooking } = useBooking();
  return (
    <footer className="site-footer" id="footer" data-testid="site-footer" style={{ backgroundImage: `url(${footerVandaImg})` }}>
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" className="brand footer-logo-link" data-testid="footer-logo">
            <img src={logoLockupGold} alt="The Vanda" className="footer-logo-img" />
          </Link>
          <p className="footer-tagline">A Boutique Hotel in the Heart of Tura.</p>
          <p className="footer-about">The Vanda Hotel is not an introduction to Tura—it is a new way to experience it. Like the orchid it is named after, it does not try to stand apart. It simply belongs, so completely, that it becomes unmistakable.</p>
        </div>
        <div>
          <p className="foot-h">Explore</p>
          <ul>
            {nav.map((item) => (
              <li key={item.label}>
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="foot-h">Visit Us</p>
          <p className="foot-line" data-testid="footer-address">Address line 1, Tura, West Garo Hills, Meghalaya, 794101, India</p>
          <p className="foot-line foot-line-phone">
            <Phone size={14} /> +91 98763 43210
          </p>
          <p className="foot-h foot-h-follow">Follow</p>
          <div className="socials">
            <a href="#top" aria-label="Instagram" data-testid="instagram-link">
              <Instagram size={19} />
            </a>
            <a href="#top" aria-label="Facebook" data-testid="facebook-link">
              <Facebook size={19} />
            </a>
          </div>
          <button onClick={openBooking} className="btn btn-outline light small" data-testid="footer-book-now">
            Book Your Stay <ArrowRight size={14} />
          </button>
        </div>
      </div>
      <div className="footer-strip">
        <small>© {new Date().getFullYear()} The Vanda · Boutique Hotel, Tura</small>
        <div className="footer-legal">
          <a href="#" data-testid="privacy-policy-link">Privacy Policy</a>
          <a href="#" data-testid="terms-link">Terms &amp; Conditions</a>
        </div>
      </div>
    </footer>
  );
}
